import { useEffect } from "react";
import { useRouteError, isRouteErrorResponse } from "react-router-dom";
import * as Sentry from "@sentry/browser";

import { getText } from "shared/lib";

export function ErrorPage() {
  const error = useRouteError();
  let errorMessage: string;

  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    errorMessage = error.data.message || error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === "string") {
    errorMessage = error;
  } else {
    console.error(error);
    errorMessage = getText("Unknown error");
  }

  useEffect(() => {
    console.error("<ErrorPage> error", error);
    Sentry.captureException(error);
  }, [error]);

  return (
    <div
      id="error-page"
      className="mt-5 flex w-screen flex-col justify-center text-center"
    >
      <h1 className="text-heading5xl">{getText("Oops!")}</h1>
      <p className="text-heading3xl">
        {getText("Sorry, an unexpected error has occurred.")}
      </p>
      <p className="text-heading3xl">
        {getText("You can try refreshing your browser to see if that helps.")}
      </p>
      <p className="text-heading3xl">
        <i className="text-slate-600">{errorMessage}</i>
      </p>
    </div>
  );
}
